import Description from '@picsart/growth-rc/Description';
import { IconCrossCircleFilled } from '@picsart/design-system/foundation/icons/IconCrossCircleFilled';
import { Overlay } from '@picsart/design-system/components/Overlay';
import useMonetizationDataStore from 'stores/monetizationDataStore';
import useStyles from './styles';
import { RedeemErrorModalProps } from './types';

function ReddemErrorModal({ setIsModalOpen, errorMessage }: RedeemErrorModalProps) {
  const styles = useStyles();
  const monetizationPopupTrigger = useMonetizationDataStore(x => x.monetizationPopupTrigger);
  const closeErrorModal = () => {
    setIsModalOpen(false);
    monetizationPopupTrigger(false);
  };
  return (
    <Overlay closeCallback={closeErrorModal} zIndex={99}>
      <div className={styles.root}>
        <IconCrossCircleFilled
          fill="var(--accents-tertiary-base-active-action)"
          className={styles.closeIcon}
          onClick={closeErrorModal}
          data-testid="close-icon"
        />
        <IconCrossCircleFilled
          fill="var(--statuses-error-base-default)"
          className={styles.errorIcon}
        />
        <Description text={errorMessage} className={styles.description} />
      </div>
      ;
    </Overlay>
  );
}

export default ReddemErrorModal;
